//ARCGIS Start
import webMap from '@arcgis/core/WebMap';
import MapView from '@arcgis/core/views/MapView';
import Basemap from "@arcgis/core/Basemap";
import VectorTileLayer from "@arcgis/core/layers/VectorTileLayer";
import Extent from "@arcgis/core/geometry/Extent";
import esriConfig from "@arcgis/core/config";
import * as urlUtils from "@arcgis/core/core/urlUtils";
import './map.css';
export function initializeVectorTileMap(options) {
    // if (options.enableProxy) {
    //#region start configer proxy on Map
    if (options.urlPrefix?.length > 0) {
        let item = options.urlPrefix;
        for (let index = 0; index < item.length; index++) {
            const el = item[index];
            urlUtils.addProxyRule({
                proxyUrl: options.proxyURL,
                urlPrefix: el
            });
        }
        esriConfig.request.proxyUrl = options.proxyURL;
    }
    if (options.urlsInterceptors?.length > 0) {
        esriConfig.request.interceptors?.push({
            urls: options.urlsInterceptors,
            headers: {
                'KACode': ''
            },
            before: options.injectSecurityCode
        });
    }
    //#endregion
    //}
    let basemap = new Basemap({
        baseLayers: [
            new VectorTileLayer({
                url: options.vectorTileURL
            })
        ],
        thumbnailUrl: options.thumbnailUrl,
        title: options.title,
        id: options.id
    });
    const map = new webMap({
        basemap: basemap
    });
    const view = new MapView({
        container: options.divContainer,
        extent: new Extent({
            xmax: 65.94007328639653,
            xmin: 23.75248891122779,
            ymax: 33.42665681913392,
            ymin: 14.552107351284993,
        }),
        map: map,
        constraints: {
            minScale: options.minScale //18489334.715908278
        }
    });
    view.when(() => {
        options.attributionControl == false ? view.ui.remove("attribution") : null;
        options.zoomControl !== "remove" ?
            view.ui.move(["zoom"], options.zoomControl) :
            view.ui.remove("zoom");
    }, (error) => {
        console.log('error', error);
    });
    return view;
}
